import { render, staticRenderFns } from "./CadastrarPlataforma.vue?vue&type=template&id=7403a6b8"
import script from "./CadastrarPlataforma.vue?vue&type=script&lang=js"
export * from "./CadastrarPlataforma.vue?vue&type=script&lang=js"
import style0 from "./CadastrarPlataforma.vue?vue&type=style&index=0&id=7403a6b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports